import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app__form__password" }
const _hoisted_2 = ["value", "type", "aria-label", "aria-invalid"]
const _hoisted_3 = ["aria-label"]

import { ref } from 'vue';
import InputField from './Field.vue';


const __default__ = {
	name: 'InputPassword',
	inheritAttrs: false,
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
	modelValue: {
		type: String,
		default: '',
	},
	label: String,
	error: Object,
	require: Boolean,
	toggleMask: Boolean,
	feedback: Boolean,
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {



const emit = __emit;
const isVisible = ref(false);

const onInput = (event: Event) => {
	emit('update:modelValue', (event.target as HTMLInputElement).value);
};

return (_ctx: any,_cache: any) => {
  const _component_app_icon = _resolveComponent("app-icon")!

  return (_openBlock(), _createBlock(InputField, {
    label: __props.label,
    error: __props.error,
    require: __props.require
  }, {
    textprepend: _withCtx(() => [
      _renderSlot(_ctx.$slots, "textprepend")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("input", _mergeProps(_ctx.$attrs, {
          value: __props.modelValue,
          type: isVisible.value ? 'text' : 'password',
          "aria-label": __props.label || 'Hasło',
          "aria-invalid": Boolean(__props.error),
          class: "p-inputtext p-component",
          onInput: onInput
        }), null, 16, _hoisted_2),
        (__props.toggleMask)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "app__form__password__toggle",
              "aria-label": isVisible.value ? 'Ukryj hasło' : 'Pokaż hasło',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isVisible.value = !isVisible.value))
            }, [
              _createVNode(_component_app_icon, {
                name: isVisible.value ? 'eyeOff' : 'eye',
                size: 20
              }, null, 8, ["name"])
            ], 8, _hoisted_3))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["label", "error", "require"]))
}
}

})